export default "__VITE_ASSET__BBgRK6Mq__"